export default __webpack_public_path__ + "static/media/35.b6b47cd6.jpg";